import { BulbIcon, SparklesIcon, ZapIcon, SourceCodeIcon } from "hugeicons-react"
import { ReactComponent as CognoraLogoIcon } from "../assets/svg/CognoraLogo.svg"
import { AI_LOGOS } from "../assets/CustomSvgs"
import '../Styles/Layout/Model/ModelModal.css'
import type { ModelIconKey, ModelLab } from "../types/model"

type IconSource = { icon?: ModelIconKey; lab: ModelLab };

export const getModelIcon = (source: IconSource) => {
    const brand = (source.icon ?? source.lab) as ModelIconKey;
    switch (brand) {
        case "auto-icon":
            return <CognoraLogoIcon width={18} height={18} className="model-logo" aria-hidden />
        case "instant-icon":
            return <ZapIcon size={32} className="model-logo" aria-hidden />
        case "thinking-icon":
            return <BulbIcon size={32} className="model-logo" aria-hidden />
        case "code-icon":
            return <SourceCodeIcon size={32} className="model-logo" aria-hidden />
        case "openai":
            return <img src={AI_LOGOS.OPENAI} alt="OpenAI" width={18} height={18} className="model-logo" />
        case "anthropic":
            return <img src={AI_LOGOS.ANTHROPIC} alt="Anthropic" width={24} height={24} className="model-logo" />
        case "xai":
            return <img src={AI_LOGOS.XAI} alt="xAI" width={18} height={18} className="model-logo" />
        case "google":
            return <img src={AI_LOGOS.GOOGLE} alt="Google" height={18} width={18} />
        case "deepseek":
            return <img src={AI_LOGOS.DEEPSEEK} alt="DeepSeek" width={18} height={18} />
        default:
            return <SparklesIcon size={24} aria-hidden />
    }
}